import React from 'react';
import useA2PRegistrationBannerStatus from './useA2PRegistrationBannerStatus';
export default function A2PReminderStatus(_a) {
    var enabled = _a.enabled;
    var isAtRisk = useA2PRegistrationBannerStatus() === 'NOT_REGISTERED';
    var label = enabled ? 'ENABLED' : 'DISABLED';
    if (isAtRisk)
        label = 'AT RISK';
    return (React.createElement("span", { className: "sub-text " + (isAtRisk || !enabled ? 'error-text' : 'success-text'), role: "status", "aria-live": "polite" }, label));
}
